import React from 'react';
import logo from '../../../../resources/img/logo_white.svg';
import facebook from '../../../../resources/img/social/facebook.svg';
import instagram from '../../../../resources/img/social/instagram.svg';
import twitter from '../../../../resources/img/social/twitter.svg';
import youtube from '../../../../resources/img/social/youtube.svg';
import { NavLink } from 'react-router-dom';

const Footer = () => (
  <div className='footer'>
    <div className='main content'>
      <div className='logo'>
        <NavLink to='/'>
          <img src={logo} />
        </NavLink>
      </div>
      <div className='area'>
        <p>&copy;2021 Selo construcciones y reformas SL.</p>
        <p class='mini'>NIF B16736977 - Inscrita en el Registro  Mercantil de Barcelona con número 2585,</p>
        <p class='mini'>libro 1357 Tomo 47965, folio 23, Hoja B567705, inscripción 1.</p>
      </div>
      <div className='social'>
        <a href='https://instagram.com' title='instagram' target="_blank">
          <img className='instagram' src={instagram} />
        </a>
        <a href='https://youtube.com' title='youtube' target="_blank">
          <img className='youtube' src={youtube} />
        </a>
        <a href='https://facebook.com' title='facebook' target="_blank">
          <img className='facebook' src={facebook} />
        </a>
        <a href='https://twitter.com' title='twitter' target="_blank">
          <img className='twitter' src={twitter} />
					</a>
      </div>
    </div>
  </div>
);

export default Footer;
